import { Component, Input } from "@angular/core";

@Component({
    selector: 'app-help-icon',
    templateUrl: './help-icon.component.html',
    styleUrls: ['./help-icon.component.css'],
    standalone: false
})
export class HelpIconComponent {
  @Input() width!: string;
  @Input() height!: string;
  @Input() color!: string;
};
